import React from "react";

export function LoadingIndicator() {
    return (
        <div className="spinner-border text-light" role="status">
            <span className="visually-hidden">Loading...</span>
        </div>
    )
}